module.exports = __webpack_public_path__ + "img/RR Power Projects logo.6c72c61f.png";